import QuubRegular from './Quub/QUUBRegular.ttf';
import QuubMedium from './Quub/QUUBMedium.ttf';
import QuubBold from './Quub/QUUBBold.ttf';
import RobotoRegular from './Roboto/RobotoRegular.ttf';
import LatoRegular from './Lato/LatoRegular.ttf';

export default function useFonts() {
    return {QuubRegular,QuubMedium,QuubBold,RobotoRegular,LatoRegular}
}
